import * as yup from 'yup'

export const schemaAccount = yup.object().shape({
  companyName: yup.string(),
  tradeName: yup.string().required(),
  name: yup.string().required(),
  phone: yup
    .string()
    .min(14)
    .max(15)
    .required(),
  value: yup.string(),
})

export default schemaAccount
